

import ajaxFactory from '../ajax/ajax-factory';
import baseService from '../services/base-service';
import constants from '../consts/index';
import configs from '../config/forgot-password';
import commonComponents from '../components/common/index';
import createAngularApplication from '../create-angular-application';
import commonConfig from '../config/common/index';
import directives from '../directives/index';
import queryParamService from '../services/query-param-service';
import forgotPasswordController from '../controllers/forgot-password/forgot-password';
import exceptionHandler from '../services/exception-handler';
import httpInterceptor from '../config/common/http-interceptor';
import userService from '../services/user-service';
import fillWithStar from '../filters/fill-with-star';
import leadingZeroFilter from '../filters/leading-zero';

var app = createAngularApplication();
app.requires.push('vcRecaptcha');

configs(app);
constants(app);
directives(app);
ajaxFactory(app);
baseService(app);
commonConfig(app);
commonComponents(app);
queryParamService(app);
forgotPasswordController(app);
exceptionHandler(app);
httpInterceptor(app);
userService(app);
fillWithStar(app);
leadingZeroFilter(app);

// var unitTest = "@@@UNIT_TEST_CONTROLLER@@@";
